$(document).ready(function(){
$('.banner-custom-first').slick({
  dots: false,
  arrow: true,
  infinite: true,
  speed: 2500,
  slidesToShow: 1,
  autoplay:true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$(".best-seller-product").contents().insertAfter(".price-filter-wrapper");

$('.list-grid-custom span').on('click',function(e) {
    if($(this).hasClass('list')) {
        $('#ProductGridContainer ul').removeClass('grid').addClass('list');
    }
    else if ($(this).hasClass('grid')) {
        $('#ProductGridContainer ul').removeClass('list').addClass('grid');
    }
});


$(".text-cate-custom ul li").each(function(){
const url = window.location.href;
const urlParts = url.split('/');
const lastPart = urlParts.pop() || urlParts.pop(); // Handle trailing slash

const lsastPart = lastPart.replace(/-/g, " ");
 

let myString = lsastPart;
let indexOfSpace = myString.indexOf(" ");
myString = myString.substr(0, 1).toUpperCase() + myString.substr(1, indexOfSpace) + "" + myString.substr(indexOfSpace + 1, 1).toUpperCase() + myString.substr(indexOfSpace + 2);

console.log(myString);


var new_text1=$(this).text();
console.log(new_text1);
  
   if(myString==new_text1){
     
 
       $(this).addClass('active');
      
   }else if(myString=='CCalcium'){
      $(".Calcium").parent().addClass('active');
 $(".Calcium").parent().siblings().removeClass('active');
    }else{
     $(this).removeClass('active');
   }
   

    
    
});






  

$(".text-cate-custom ul li a").each(function(){

$(this).click(function(){
var new_text=$(this).text();

    sessionStorage.setItem("collect_name_click", new_text);
    
});
    
    
});

$(".text-cate-custom ul li").each(function(){
var new_gh1=sessionStorage.getItem("collect_name_click");

var new_text1=$(this).text();
console.log(new_text1);
  if(new_gh1 != null){
   if(new_gh1==new_text1){
     
 
       $(this).addClass('active');
      
   }else{

     $(this).removeClass('active');
   }
   } 

    
    
});

  if ($("body").hasClass("collection") != true) {
    sessionStorage.removeItem('collect_name_click');
  }

// blog part

$(".cstm_heading_section_blog_post .cstm_heading_section .tab-heading-sect h4 a").each(function(){

$(this).click(function(){
var blog_text=$(this).text();

    sessionStorage.setItem("blog_name_click", blog_text);
    
});
    
    
});


$(".cstm_heading_section_blog_post .cstm_heading_section .tab-heading-sect h4 a").each(function(){
var blog_gh1=sessionStorage.getItem("blog_name_click");

var blog_text1=$(this).text();
console.log(blog_text1);
 if(blog_gh1 != null){
   if(blog_gh1==blog_text1){
     
 
       $(this).addClass('active');
      
   }else{

     $(this).removeClass('active');
   }
 }

    
    
});

 if ($("body").hasClass("blog") != true) {
    sessionStorage.removeItem('blog_name_click');
  }


  
// price filter

  $(".btn-cstm-apply a.action_button").click(function(){
   var id_text2=$("input#cstm-new2").val();
   var id_text1=$("input#cstm-new1").val();
sessionStorage.removeItem('qty_val1');
  sessionStorage.removeItem('qty_val2');
  sessionStorage.setItem("qty_val1", id_text1);
  sessionStorage.setItem("qty_val2", id_text2);
var new_url_cstm=window.location.href;
new_url_cstm = new_url_cstm.split("?").slice(0,1).join("&");

    var cstnew_url=new_url_cstm + '?filter.v.price.gte='+id_text1+'&filter.v.price.lte='+id_text2+'&sort_by=relevance';
    console.log(cstnew_url);
    window.location.href = cstnew_url;
  
});

  var new_gh1=sessionStorage.getItem("qty_val1");

  var new_gh2=sessionStorage.getItem("qty_val2");
$("input#cstm-new1").val(new_gh1);
$("input#cstm-new2").val(new_gh2);


  $(".btn-cstm-remove a.action_button").click(function(){
sessionStorage.removeItem('qty_val1');
  sessionStorage.removeItem('qty_val2');
var new_url_cstm2=window.location.href;
new_url_cstm2 = new_url_cstm2.split("?").slice(0,1).join("&");
    window.location.href = new_url_cstm2;
});
if(new_gh1 == null)
{
  $(".btn-cstm-remove a.action_button").css("display","block");
$("input#cstm-new1").val('25')
$("input#cstm-new2").val('251')
}


// $(".text-cate-custom li:first").addClass("active"); 


// relod page after on change 
 $(".select select#SortBy").change(function() {
// alert();
        setTimeout(function () {
  location.reload();
        }, 1000); 
});



 
     $(".set > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content")
        .slideUp(200);
      $(".set > a i")
        .removeClass("fa fa-chevron-up")
        .addClass("fa fa-chevron-down");
    } else {
      $(".set > a i")
        .removeClass("fa fa-chevron-up")
        .addClass("fa fa-chevron-down");
      $(this)
        .find("i")
        .removeClass("fa fa-chevron-down")
        .addClass("fa fa-chevron-up");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
        .siblings(".content")
        .slideDown(200);
    }
  });


   $('.featured_main_image').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: '<button type="button" class="slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
  nextArrow: '<button type="button" class="slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
  fade: true,
  asNavFor: '.featured_thumb_nail_image'
});
$('.featured_thumb_nail_image').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.featured_main_image',
  dots: false,
  arrows: true,
  vertical: true,
  verticalSwiping: true,
  focusOnSelect: true,
   responsive: [
    {
        breakpoint: 991,
        settings: {
         vertical: true,
        }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: false,
      }
    },
    {
      breakpoint: 580,
      settings: {
        vertical: false,
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 480,
      settings: {
        vertical: false,
        slidesToShow: 3,
      }
    }
    ]
});


$( ".cstm_heading_section .tab-heading-sect h4 a" ).each(function() {
   var new_jjj=$(this).text();
var string = window.location.href;
var segments = string.split("/");
var last = segments[segments.length-1];
if(last == new_jjj ) {
    $(this).addClass("active");
  } 

  });


     $('a.btn-per').click(function () {
       $(this).addClass("active");
       $("a.btn-pat").removeClass("active");
        $('.contact-form-perf').css('display', 'block'); 
       $('.tab1').css('display', 'none'); 
    });
 $('a.btn-pat').click(function () {
   $(this).addClass("active");
   $("a.btn-per").removeClass("active");
        $('.tab1').css('display', 'block');  
      $('.contact-form-perf').css('display', 'none');
    });

$('.slide-mobile').slick({
  dots: false,
  infinite: false,
  speed: 300,
  centerMode: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        prevArrow: '<button type="button" class="slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


  $(".bar-time i.fa.fa-bars").click(function(){
    $(".cateory-heading-custom.col-md-3").addClass("toggle-cust");
  });
  $(".bar-time i.fa.fa-times").click(function(){
    $(".cateory-heading-custom.col-md-3").removeClass("toggle-cust");
  });
  $("i.fa.fa-bars").click(function(){
     $(".fa.fa-times").addClass("active");
    $(".fa.fa-bars").removeClass("active");
    
  });$("i.fa.fa-times").click(function(){
    $(".fa.fa-bars").addClass("active");
    $(".fa.fa-times").removeClass("active");
  });
 

   $(".bar-time i.fa.fa-bars").click(function(){
      $('body').addClass('sticky-back')
    });
$(".bar-time i.fa.fa-times").click(function(){
      $('body').removeClass('sticky-back')
    });



//   $(".blog__post.grid__item.article.slider__slide.slider__slide--full-width1 .article-card-wrapper.card-wrapper.underline-links-hover .card.article-card .card__content h3.card__heading.h2").click(function(){
// event.preventDefault();

// var current_url=window.location.href;
//     var new_url=current_url+'collections/bariatric-multivitamins';

//     console.log(new_url);
//    window.location.replace(new_url);
    
// }); 
// $(".blog__post.grid__item.article.slider__slide.slider__slide--full-width2 .article-card-wrapper.card-wrapper.underline-links-hover .card.article-card .card__content h3.card__heading.h2").click(function(){
// event.preventDefault();

// var current_url=window.location.href;
//     var new_url=current_url+'collections/calcium';

//     console.log(new_url);
//    window.location.replace(new_url);
    
// }); 
// $(".blog__post.grid__item.article.slider__slide.slider__slide--full-width3 .article-card-wrapper.card-wrapper.underline-links-hover .card.article-card .card__content h3.card__heading.h2").click(function(){
// event.preventDefault();

// var current_url=window.location.href;
//     var new_url=current_url+'collections/supporting-supplements';

//     console.log(new_url);
//    window.location.replace(new_url);
    
// }); 



// $(".blog__post.grid__item.article.slider__slide.slider__slide--full-width3 .article-card-wrapper.card-wrapper.underline-links-hover .card.article-card .card__content .read-more-custom-button").click(function(){
// event.preventDefault();

// var current_url=window.location.href;
//     var new_url=current_url+'collections/supporting-supplements';

//     console.log(new_url);
//    window.location.replace(new_url);
    
// });

//  $(".blog__post.grid__item.article.slider__slide.slider__slide--full-width1 .article-card-wrapper.card-wrapper.underline-links-hover .card.article-card .card__content .read-more-custom-button").click(function(){
// event.preventDefault();

// var current_url=window.location.href;
//     var new_url=current_url+'collections/bariatric-multivitamins';

//     console.log(new_url);
//    window.location.replace(new_url);
// });

//   $(".blog__post.grid__item.article.slider__slide.slider__slide--full-width2 .article-card-wrapper.card-wrapper.underline-links-hover .card.article-card .card__content .read-more-custom-button").click(function(){
// event.preventDefault();

// var current_url=window.location.href;
//     var new_url=current_url+'collections/calcium';

//     console.log(new_url);
//    window.location.replace(new_url);
    
// });
  
  
  });